var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("h1", [_vm._v(_vm._s(_vm.$t("delegationTask.title")))]),
      _c(
        "v-row",
        { staticStyle: { "margin-bottom": "15px" } },
        [
          _c(
            "v-col",
            { attrs: { cols: "3" } },
            [
              _c("v-text-field", {
                attrs: {
                  label: _vm.$t("global.search"),
                  "append-icon": "search",
                  "hide-details": "",
                  "single-line": ""
                },
                model: {
                  value: _vm.search,
                  callback: function($$v) {
                    _vm.search = $$v
                  },
                  expression: "search"
                }
              })
            ],
            1
          ),
          _c("v-spacer"),
          _c(
            "div",
            [
              _c(
                "delegation-task-form",
                { on: { saved: _vm.load } },
                [
                  _c("v-btn", { attrs: { block: "", color: "accent" } }, [
                    _vm._v(
                      _vm._s(_vm.$t("delegationTask.newDelegationTask")) + " "
                    )
                  ])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c("v-data-table", {
        attrs: {
          headers: _vm.headers,
          items: _vm.delegationTask,
          "footer-props": {
            "items-per-page-options": [
              { text: "$vuetify.dataIterator.rowsPerPageAll", value: -1 }
            ]
          },
          search: _vm.search,
          "hide-default-footer": ""
        },
        scopedSlots: _vm._u([
          {
            key: "item",
            fn: function(props) {
              return [
                _c("tr", [
                  _c(
                    "td",
                    { staticClass: "text-left" },
                    [
                      _c(
                        "v-tooltip",
                        {
                          attrs: { bottom: "" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "activator",
                                fn: function(ref) {
                                  var on = ref.on
                                  return [
                                    _c(
                                      "v-btn",
                                      _vm._g(
                                        {
                                          attrs: {
                                            disabled:
                                              props.item.list_order === 1,
                                            icon: ""
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.moveUp(props.item)
                                            }
                                          }
                                        },
                                        on
                                      ),
                                      [
                                        _c("v-icon", [
                                          _vm._v("fa-arrow-alt-circle-up")
                                        ])
                                      ],
                                      1
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            true
                          )
                        },
                        [_vm._v(" " + _vm._s(_vm.$t("global.moveUp")) + " ")]
                      ),
                      _vm._v(" " + _vm._s(props.item.list_order) + " "),
                      _c(
                        "v-tooltip",
                        {
                          attrs: { bottom: "" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "activator",
                                fn: function(ref) {
                                  var on = ref.on
                                  return [
                                    _c(
                                      "v-btn",
                                      _vm._g(
                                        {
                                          attrs: {
                                            disabled:
                                              props.item.list_order ===
                                              _vm.delegationTask.length,
                                            icon: ""
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.moveDown(props.item)
                                            }
                                          }
                                        },
                                        on
                                      ),
                                      [
                                        _c("v-icon", [
                                          _vm._v("fa-arrow-alt-circle-down")
                                        ])
                                      ],
                                      1
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            true
                          )
                        },
                        [_vm._v(" " + _vm._s(_vm.$t("global.moveDown")) + " ")]
                      )
                    ],
                    1
                  ),
                  _c("td", { staticClass: "text-left" }, [
                    _vm._v(" " + _vm._s(_vm.getName(props.item)) + " ")
                  ]),
                  _c("td", { staticClass: "text-left" }, [
                    props.item.is_comment_required === 1
                      ? _c("span", [_vm._v(_vm._s(_vm.$t("global.yes")))])
                      : _vm._e(),
                    props.item.is_comment_required === 0
                      ? _c("span", [_vm._v(_vm._s(_vm.$t("global.no")))])
                      : _vm._e()
                  ]),
                  _c("td", { staticClass: "text-left" }, [
                    props.item.is_enabled === 1
                      ? _c("span", [_vm._v(_vm._s(_vm.$t("global.yes")))])
                      : _vm._e(),
                    props.item.is_enabled === 0
                      ? _c("span", [_vm._v(_vm._s(_vm.$t("global.no")))])
                      : _vm._e()
                  ]),
                  _c(
                    "td",
                    {
                      staticClass: " justify-center align-content-center px-0"
                    },
                    [
                      props.item.used_in_delegations > 0
                        ? _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "delegationTask.taskEditAppliesNTimes",
                                  props.item.used_in_delegations,
                                  { count: props.item.used_in_delegations }
                                )
                              ) + " "
                            ),
                            _c("br")
                          ])
                        : _vm._e(),
                      props.item.used_in_delegations === 0
                        ? _c("span", [
                            _vm._v(
                              _vm._s(_vm.$t("delegationTask.taskZeroTimes"))
                            ),
                            _c("br")
                          ])
                        : _vm._e(),
                      props.item.is_system_value > 0
                        ? _c("span", [
                            _vm._v(_vm._s(_vm.$t("delegationTask.systemItem")))
                          ])
                        : _vm._e()
                    ]
                  ),
                  _c(
                    "td",
                    { staticClass: "text-no-wrap text-center" },
                    [
                      _c("delegation-task-form", {
                        attrs: { "delegation-task": props.item },
                        on: {
                          "update:delegationTask": function($event) {
                            return _vm.$set(props, "item", $event)
                          },
                          "update:delegation-task": function($event) {
                            return _vm.$set(props, "item", $event)
                          },
                          saved: _vm.load
                        }
                      }),
                      _c(
                        "v-tooltip",
                        {
                          attrs: { bottom: "" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "activator",
                                fn: function(ref) {
                                  var on = ref.on
                                  return [
                                    !props.item.is_system_value &&
                                    props.item.used_in_delegations === 0
                                      ? _c(
                                          "v-btn",
                                          _vm._g(
                                            {
                                              attrs: { icon: "" },
                                              on: {
                                                click: function($event) {
                                                  return _vm.removeDelegationTask(
                                                    props.item
                                                  )
                                                }
                                              }
                                            },
                                            on
                                          ),
                                          [_c("v-icon", [_vm._v("delete")])],
                                          1
                                        )
                                      : _vm._e()
                                  ]
                                }
                              }
                            ],
                            null,
                            true
                          )
                        },
                        [_vm._v(" " + _vm._s(_vm.$t("global.delete")) + " ")]
                      )
                    ],
                    1
                  )
                ])
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }